/**
 * Yedekle ilgili, kasanın şifreli ayarlarında duran anahtarlar. Ayrı dosyada:
 * `elleYedek.ts` ile `otoIndir.ts` birbirini içe aktarmasın.
 */

/** Son elle (ya da otomatik) yedekteki kasanın özeti — kalıcı depolama uyarısı için. */
export const ELLE_YEDEK_AYARI = "yedek.elleOzet";
/** Son indirmedeki kasanın iki özeti, zamanı ve dosya adı (`otoIndir.ts`). */
export const SON_INDIRME_AYARI = "yedek.sonIndirme";
/** "Değişiklikte otomatik indir" anahtarı: "kapali" yazılmadıkça açık. */
export const OTO_INDIR_AYARI = "yedek.otoIndir";
/** Değişiklikten sonra indirmeye kadar bekleme (saniye). */
export const OTO_INDIR_BEKLEME_AYARI = "yedek.otoIndirBeklemeSn";
